import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input input-mini d-flex j-content-start p-none pr-1" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "w-100 text-center text-phone" }

import { computed, ref, watch, onBeforeMount } from "vue";
import { IStore } from "@/store/types/StoreType";
import { Field, useField } from "vee-validate";
import { useStore } from "vuex";
import { vMaska } from "maska";


export default /*#__PURE__*/_defineComponent({
  __name: 'phoneComponent',
  props: {
    value: {},
    name: {},
    start: {},
    change: {},
    tabindex: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore<IStore>();


const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
const phone = ref(props.value.replace(/[^\d.]+/g, ""));
const start = ref(props.start);

const switchPhone = () => {
  start.value === "+358" ? (start.value = "+46") : (start.value = "+358");
  resetField({
    value: start.value,
  });
  store.commit(props.change, start.value);
};
const { resetField, value } = useField(
  props.name + "_start",
  (value: string) => value
);

const change = () => {
  if (phone?.value?.length <= 0 || value.value.length <= 0) {
    if (uiLang.value === "Swedish") start.value = "+46";
    else start.value = "+358";
    resetField({
      value: start.value,
    });
    store.commit(props.change, start.value);
  }
};

watch(
  () => uiLang.value,
  () => {
    change();
  },
  { deep: true }
);
watch(
  () => props.value,
  () => {
    phone.value = props.value.replace(/[^\d.]+/g, "");
  }
);
onBeforeMount(() => {
  if (props?.start?.length <= 0) change();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _withModifiers(switchPhone, ["stop"]),
        class: _normalizeClass(["d-flex a-i-center text-raleway-18 pointer phone-change pl-1 transition-015 no-select", {
          fn: props.start === '+358',
          sw: props.start !== '+358',
        }])
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(props.start), 1)
      ], 10, _hoisted_3),
      _withDirectives(_createVNode(_unref(Field), {
        type: "text",
        name: props.name,
        class: "w-100 b-none outline-none text-raleway-18",
        "data-maska": props.start === '+358' ? '###-###-###' : '###-###-####',
        value: phone.value,
        tabindex: props.tabindex,
        placeholder: props.start === '+358' ? '###-###-###' : '###-###-####'
      }, null, 8, ["name", "data-maska", "value", "tabindex", "placeholder"]), [
        [_unref(vMaska)]
      ])
    ])
  ]))
}
}

})